import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { useAuth } from '../contexts/AuthContext';
import { firestore } from './firebaseConfig';
import PlayerProfileModal from '../components/PlayerProfileModal';

export default function ProfilePage() {
  const { user, profile } = useAuth();
  const navigate = useNavigate();
  const [player, setPlayer] = useState(profile ? { id: user?.uid, ...profile } : null);

  useEffect(() => {
    if (!user?.uid) return;
    let mounted = true;
    getDoc(doc(firestore, 'userprofiles', user.uid)).then((snap) => {
      if (mounted) setPlayer(snap.exists() ? { id: snap.id, ...snap.data() } : { id: user.uid, ...(profile || {}) });
    });
    return () => { mounted = false; };
  }, [profile, user]);

  return (
    <div className="p4r-profile-route-shell">
      <PlayerProfileModal
        show
        player={player || { id: user?.uid }}
        onHide={() => navigate('/players')}
      />
    </div>
  );
}
